module.exports = __webpack_public_path__ + "static/smart_3-e8fa3df68a335368d6e433531f54eccb.png";